export const companys = [
    {
        name: 'Reliance HMO',
        img: '/images/health/reliance-hmo.png',
        benefits: [
            'Combined medical cover of ₦1.2 Million naira a year',
            'Access to health specialists (based on referral)',
            '₦150,000 for 9 different surgeries available yearly',
            'Free wellness and health checks at selected Reliance centres',
            'Access to eye and dental care',
            'Access to gym',
            'Consult with doctors for free from anywhere',
            'Instant access to healthcare',
            'Access to 677 hospitals all over Nigeria'
        ],
        price: 3500,
    },
    {
        name: 'Avon HMO',
        img: '/images/health/avon-hmo.png',
        benefits: [
            'General Consultation',
            'Specialist Consultation',
            'Lab Investigations',
            'Physiotherapy',
            'Feeding on Admission',
            'Travel Immunization',
            'Prescribed Drugs',
        ],
        price: 3585,
    },
    {
        name: 'AXA Mansard',
        img: '/images/health/axa-mansard.png',
        benefits: [
            'Primary/Secondary Dental Care',
            'Out Patient Care, General and Specialist Consultation',
            'Admissions (Including Feeding)',
            'Prescribed Medicines And Drugs',
            'Psychiatry Cover up to 8 Weeks',
            'Physiotherapy Sessions',
            'X-Rays, Laboratory & Diagnostic Tests',
        ],
        price: 4200,
    },
    {
        name: 'Hygeia HMO',
        img: '/images/health/hygeia-hmo.svg',
        benefits: [
            'Intermediate & Major Surgeries (including Caesarean Delivery)',
            'Ambulance',
            'Basic X-Rays and Ultrasounds',
            'Ear, Nose and Throat care',
            'Dental Care',
            'Telemedicine Consultations',
            'Physiotherapy',
        ],
        price: 5000,
    },
    {
        name: 'Clearline HMO',
        img: '/images/health/clearline-hmo.png',
        benefits: [
            'Outpatient & Specialist consultation',
            'Prescribed medicines & drugs',
            'Routine Immunizations & other Child welfare clinic services',
            'Accident & Emergencies',
            'Advanced Radiological Investigations (CT Scan, MRI)',
            'Primary dental care',
            'Annual routine medical check',
        ],
        price: 4500,
    },
    {
        name: 'HCI Healthcare HMO',
        img: '/images/health/hci-healthcare.png',
        benefits: [
            'Consultation with specialist',
            'Routine medical Screening',
            'NPI-approved Immunization',
            'Acute care benefits',
            'Minor Surgeries',
            'Prescribed Medications',
            'Ward admission & Feeding',
            'Laboratory investigations, Nursing care',
        ],
        price: 3800,
    }
];

export const healthData = [
    {
        name: 'Oloyede Oluwaseyi Joshua',
        img: 'https://images.unsplash.com/flagged/photo-1561530822-3d8826007519?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80',
        relationship: 'Brother',
        company: 'AVON HMO',
        country: 'Nigeria',
        package: 1,
        price: '3585',
        due: 'March 19, 2021',
    },
    {
        name: 'Mide Ogunnola',
        img: '',
        relationship: 'Father',
        company: 'HCI Healthcare HMO',
        country: 'Nigeria',
        package: 1,
        price: '3800',
        due: 'January 21, 2021',
    },
    {
        name: 'Chioma Okoro',
        img: 'https://qph.fs.quoracdn.net/main-qimg-49fd68608efbf7e1a130d2649e00e739',
        relationship: 'Mother',
        company: 'Clearline HMO',
        country: 'Nigeria',
        package: 1,
        price: '4500',
        due: null,
    },
    {
        name: 'Ehis Aziengbe',
        img: 'https://images.unsplash.com/flagged/photo-1561530822-3d8826007519?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80',
        relationship: 'Uncle',
        company: 'Reliance HMO',
        country: 'Nigeria',
        package: 0,
        price: '3500',
        due: null,
    },
];
